module.exports = __webpack_public_path__ + "img/logo-footer-vnpt.e80916e3.png";